import { render, staticRenderFns } from "./QuestionResultTip.vue?vue&type=template&id=38830b08&scoped=true&lang=pug&"
import script from "./QuestionResultTip.vue?vue&type=script&lang=ts&"
export * from "./QuestionResultTip.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionResultTip.vue?vue&type=style&index=0&id=38830b08&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38830b08",
  null
  
)

export default component.exports